import {
  OnNetworkError,
  OnPostProductVisitError,
  OnPostViewUniverseError
} from './errors.types'

export const NETWORK_ERROR = 'NETWORK_ERROR'
export const POST_PRODUCT_VISIT_ERROR = 'POST_PRODUCT_VISIT_ERROR'
export const POST_VIEW_UNIVERSE_ERROR = 'POST_VIEW_UNIVERSE_ERROR'

export const onNetworkError: OnNetworkError = error => ({
  payload: { error },
  type: NETWORK_ERROR
})

export const onPostProductVisitError: OnPostProductVisitError = error => ({
  payload: { error },
  type: POST_PRODUCT_VISIT_ERROR
})

export const onPostViewUniverseError: OnPostViewUniverseError = error => ({
  payload: { error },
  type: POST_VIEW_UNIVERSE_ERROR
})
